/* eslint-disable react/no-array-index-key */
import type { BasketMessagesViewModel } from 'autogen/swagger/all';
import { BasketMessageDiscriminator, type BasketMessageWrapper } from 'autogen/swagger/all';
import { CampaignBasketNudge } from 'components/features/CampaignInfo';
import type { ReactNode } from 'react';
import { BasketMessages } from '.';

export default function BasketMessageRenderer({
    model: { achievements, information, nudgingMessages, matasPlusMessages }
}: {
    model: BasketMessagesViewModel;
}) {
    const mapper = (model: BasketMessageWrapper['basketMessage'], index: number) =>
        BasketMessageDiscriminator<ReactNode>(
            model,
            (clickAndCollectModel) => <BasketMessages.ClickAndCollect model={clickAndCollectModel} />,
            (discountModel) => <CampaignBasketNudge model={discountModel} key={index} />,
            (gwpModel) => <BasketMessages.Gwp model={gwpModel} key={index} />,
            (matasPlusModel) => <BasketMessages.MatasPlus model={matasPlusModel} key={index} />,
            (sameDayDeliveryModel) => <BasketMessages.SameDayDelivery model={sameDayDeliveryModel} key={index} />,
            (sampleModel) => <BasketMessages.Sample model={sampleModel} key={index} />,
            (shippingModel) => <BasketMessages.Shipping model={shippingModel} key={index} />,
            () => {
                throw new Error('invalid basket message type');
            }
        );

    return (
        <>
            {achievements.map(mapper)}
            {information.map(mapper)}
            {nudgingMessages.map(mapper)}
            {matasPlusMessages.map(mapper)}
        </>
    );
}
